const FIELD_SELECTOR = '.gfield.kw-slider';
const THUMB_SIZE = 24;

const parseNumberAttr = (input, attr, fallback) => {
	const value = parseFloat(input.getAttribute(attr));
	return Number.isFinite(value) ? value : fallback;
};

const getInitialValue = (numberInput, min, max) => {
	const value = parseFloat(numberInput.value);
	if (Number.isFinite(value)) {
		return Math.min(max, Math.max(min, value));
	}
	return min;
};

const updateBubble = (rangeInput, output, min, max) => {
	const value = parseFloat(rangeInput.value);
	const percent = max === min ? 0 : (value - min) / (max - min);
	const trackWidth = rangeInput.offsetWidth;
	const left = percent * (trackWidth - THUMB_SIZE) + THUMB_SIZE / 2;

	output.textContent = `${value} kW`;
	output.style.left = `${left}px`;
};

const syncToNumberInput = (numberInput, value) => {
	numberInput.value = value;
	numberInput.dispatchEvent(new Event('input', { bubbles: true }));
	numberInput.dispatchEvent(new Event('change', { bubbles: true }));
};

const initKwSliderField = (field) => {
	if (field.dataset.kwSliderReady === 'true') {
		return;
	}

	const numberInput = field.querySelector('.ginput_container input[type="number"]');
	if (!numberInput) {
		return;
	}

	const min = parseNumberAttr(numberInput, 'min', 0);
	const max = parseNumberAttr(numberInput, 'max', 800);
	const step = parseNumberAttr(numberInput, 'step', 1);
	const initialValue = getInitialValue(numberInput, min, max);

	const wrapper = document.createElement('div');
	wrapper.className = 'kw-slider__wrapper';

	const rangeInput = document.createElement('input');
	rangeInput.type = 'range';
	rangeInput.className = 'kw-slider__range';
	rangeInput.min = String(min);
	rangeInput.max = String(max);
	rangeInput.step = String(step);
	rangeInput.value = String(initialValue);

	const label = field.querySelector('.gfield_label');
	if (label && label.id) {
		rangeInput.setAttribute('aria-labelledby', label.id);
	}

	const output = document.createElement('output');
	output.className = 'kw-slider__output';
	output.setAttribute('aria-live', 'polite');

	const container = numberInput.closest('.ginput_container');
	container.appendChild(wrapper);
	wrapper.appendChild(rangeInput);
	wrapper.appendChild(output);

	const onSliderInput = () => {
		syncToNumberInput(numberInput, rangeInput.value);
		updateBubble(rangeInput, output, min, max);
	};

	rangeInput.addEventListener('input', onSliderInput);

	const onResize = () => {
		updateBubble(rangeInput, output, min, max);
	};

	window.addEventListener('resize', onResize);

	field.dataset.kwSliderReady = 'true';
	syncToNumberInput(numberInput, initialValue);
	requestAnimationFrame(() => {
		updateBubble(rangeInput, output, min, max);
	});
};

const initKwSliders = () => {
	document.querySelectorAll(FIELD_SELECTOR).forEach(initKwSliderField);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initKwSliders);
} else {
	initKwSliders();
}

if (window.jQuery) {
	window.jQuery(document).on('gform_post_render', initKwSliders);
}
